import { render } from "./ProjectCommentsMobileMenu.vue?vue&type=template&id=f922f4ac"
import script from "./ProjectCommentsMobileMenu.vue?vue&type=script&lang=js"
export * from "./ProjectCommentsMobileMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__